module.exports = __webpack_public_path__ + "media/images/sports_coaching/cover-desktop@3x-7c1a2a21d785364410a77e03c94db3d3.jpg";